/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Nummatches1Inputs */

const en__field_nummatches1 = /** @type {(inputs: _Field_Nummatches1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of Matches`)
};

const de__field_nummatches1 = /** @type {(inputs: _Field_Nummatches1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Matches`)
};

/**
* | output |
* | --- |
* | "Number of Matches" |
*
* @param {_Field_Nummatches1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_nummatches1 = /** @type {((inputs?: _Field_Nummatches1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Nummatches1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_nummatches1(inputs)
	return de__field_nummatches1(inputs)
});
export { _field_nummatches1 as "_field_numMatches" }